var _a, _b, _c, _d, _e;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiGetSpaces } from '@/infrastructure/api-functions/api-spaces';
import { SpaceRouteName, SpaceType } from '@/domains/spaces/enums';
import { SpaceSortTypeService } from '@/domains/spaces/services/space-sort-type-service.interface';
import { RouterService } from '@cores/services/vue-router-service';
import { SPACE_LABEL_ALL } from '@/domains/spaces/constants';
import { I18nService } from '@/services/i18n-service';
import { SpaceLabelService } from '@/domains/spaces/services/space-label-service.interface';
let SpaceLabelsRepositoryImpl = class SpaceLabelsRepositoryImpl {
    constructor(_apiGetSpaces, _spaceSortTypeService, _routerService, _i18nService, _spaceLabelService) {
        this._apiGetSpaces = _apiGetSpaces;
        this._spaceSortTypeService = _spaceSortTypeService;
        this._routerService = _routerService;
        this._i18nService = _i18nService;
        this._spaceLabelService = _spaceLabelService;
    }
    _getSpaceType() {
        const currentRouteName = this._routerService.currentRoute.name;
        const spaceType = currentRouteName === SpaceRouteName.Personal
            ? SpaceType.Personal : currentRouteName === SpaceRouteName.Shared
            ? SpaceType.Shared : currentRouteName === SpaceRouteName.Public
            ? SpaceType.Public : SpaceType.All;
        return spaceType;
    }
    _getLabelAllOption() {
        return {
            labelName: this._i18nService.t('workspace.labels.allTag'),
            labelValue: SPACE_LABEL_ALL,
        };
    }
    async querySpaceLabels() {
        const request = {
            sort_type: this._spaceSortTypeService.getSpaceSortType(),
            label_name: this._spaceLabelService.getSpaceLabel(),
            type: this._getSpaceType(),
            page: 1,
            limit: 10,
            can_access_public_space: true,
        };
        const data = await this._apiGetSpaces.getSpaces(request);
        const labels = data.labels.map((label) => ({
            labelName: label.label_name,
            count: label.count,
            labelValue: label.label_name,
        }));
        return [
            this._getLabelAllOption(),
            ...labels,
        ];
    }
};
SpaceLabelsRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiGetSpaces)),
    __param(1, inject(SpaceSortTypeService)),
    __param(2, inject(RouterService)),
    __param(3, inject(I18nService)),
    __param(4, inject(SpaceLabelService)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiGetSpaces !== "undefined" && ApiGetSpaces) === "function" ? _a : Object, typeof (_b = typeof SpaceSortTypeService !== "undefined" && SpaceSortTypeService) === "function" ? _b : Object, typeof (_c = typeof RouterService !== "undefined" && RouterService) === "function" ? _c : Object, typeof (_d = typeof I18nService !== "undefined" && I18nService) === "function" ? _d : Object, typeof (_e = typeof SpaceLabelService !== "undefined" && SpaceLabelService) === "function" ? _e : Object])
], SpaceLabelsRepositoryImpl);
export { SpaceLabelsRepositoryImpl };
